export enum GdprEmailSignatureTag {
  FULL_NAME= '$fullName',
  JOb_TITLE= '$jobTitle',
  EMAIL= '$contactOwnerEmail',
  OFFICE_PHONE= '$officePhone',
  PRIVATE_PHONE= '$privatePhone'
}
